import script from "./ClientCabinetProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientCabinetProfile.vue?vue&type=script&setup=true&lang=js"

import "./ClientCabinetProfile.vue?vue&type=style&index=0&id=86d836c6&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86d836c6"]])

export default __exports__